import { render, staticRenderFns } from "./writer.vue?vue&type=template&id=2508f2e4&scoped=true&"
import script from "./writer.vue?vue&type=script&lang=js&"
export * from "./writer.vue?vue&type=script&lang=js&"
import style0 from "./writer.vue?vue&type=style&index=0&id=2508f2e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508f2e4",
  null
  
)

export default component.exports